/*
 * @Author: your name
 * @Date: 2020-11-16 23:26:08
 * @LastEditTime: 2021-03-09 15:57:46
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vr-fornt-end\src\components\modeldemo\GodMode.js
 */

import TWEEN from 'tween.js'
import { config } from './config'
import * as THREE from 'three'
import { Camera } from './Camera'
import * as Utils from './Utils'
import { Vector3 } from 'three'


const GodViewMode = {
  Panel: 0,
  In3D: 1
}

const MathConst = {
  Tan32: Math.tan(THREE.MathUtils.degToRad(3 / 2)),
  Tan652: Math.tan(THREE.MathUtils.degToRad(65 / 2))
}

const ConfigConst = {
  ToNormalNear: 500 * MathConst.Tan652,
  ToNormalFar: 100000 * MathConst.Tan652
}

export class GodMode {
  /**
   * 上帝模式动画实例构造方法
   * @param {Camera} camera 相机实例
   * @param {SingleView} singleView 单场景点实例
   * @param {Renderer} renderer 渲染器实例
   */
  constructor (camera, singleView, renderer, center = new Vector3()) {
    /**
     * @type {number} 相机游览模式
     */
    this.viewMode = GodViewMode.Panel
    /**
     * @type {Camera} 摄像机实例
     */
    this.cameraInstance = camera
    /**
     * @type {SingleView} 单场景点实例
     */
    this.singleView = singleView
    /**
     * @type {Renderer} 渲染器实例
     */
    this.renderer = renderer

    this.center = center
  }

  /**
   * [tween] 透视相机转正交相机
   */
  async normal2Orth () {
    const cam = this.cameraInstance

    let tz = cam.zoom
    cam.cameraType = false
    if (cam.cameraMode) {
      cam.cameraMode = false
      cam.lon += 180
      tz = 1000
    }
    const tfov = 3
    cam.lon = ((cam.lon % 360) + 360) % 360
    const c = {
      fov: cam.fov,
      lon: cam.lon,
      lat: cam.lat,
      tx: cam.target.x,
      ty: cam.target.y,
      tz: cam.target.z,
      zoom: tz
    }
    this.to2Dtween = new TWEEN.Tween(c)
    // console.log(this.center)
    this.to2Dtween.to({
      fov: tfov,
      lon: cam.lon <= 90 ? 0 : cam.lon >= 270 ? 360 : 180,
      lat: 89.99,
      tx: this.center.x,
      ty: 0,
      tz: this.center.z,
      zoom: 39460
    }, 1000)
    this.to2Dtween.onUpdate(() => {
      cam.lon = c.lon
      cam.lat = c.lat
      cam.target.set(c.tx, c.ty, c.tz)
      cam.fov = c.fov
      cam.camera.near = ConfigConst.ToNormalNear / Math.tan(THREE.MathUtils.degToRad(c.fov / 2))
      cam.camera.far = ConfigConst.ToNormalFar / Math.tan(THREE.MathUtils.degToRad(c.fov / 2))
      cam.zoom = c.zoom * Math.tan(THREE.MathUtils.degToRad(65 / 2)) / Math.tan(THREE.MathUtils.degToRad(c.fov / 2))
      cam.camera.updateProjectionMatrix()
    })
    this.to2Dtween.easing(TWEEN.Easing.Quadratic.Out)
    return new Promise((resolve, reject) => {
      this.to2Dtween.onComplete(() => {
        // cam.persCamera = cam.camera
        cam.changeMainCameraTo(cam.orthCamera)
        cam.camera.updateProjectionMatrix()
        // cam.target.set(0, 0, 0)
        // cam.godUpdate()
        resolve()
      })
      this.to2Dtween.start()
    })
  }

  /**
   * [tween] 从正交相机恢复成透视相机
   * @param {THREE.Vector3} targetPos 目标中心
   * @param {boolean} toView 是否需要到目标位置
   */
  async orth2Normal (targetPos, toView) {
    const cam = this.cameraInstance

    cam.persCamera.near /= cam.camera.zoom
    cam.persCamera.far /= cam.camera.zoom
    const zoom = cam.zoom / cam.camera.zoom
    const near = cam.persCamera.near
    const far = cam.persCamera.far

    const dx = -1000 * Math.cos(THREE.MathUtils.degToRad(-cam.lon)) + targetPos.x
    const dz = 1000 * Math.sin(THREE.MathUtils.degToRad(-cam.lon)) + targetPos.z
    const dy = targetPos.y

    cam.changeMainCameraTo(cam.persCamera) // 切回了透视相机
    cam.zoom = zoom
    const c = {
      fov: cam.fov,
      lat: cam.lat,
      zoom: zoom,
      rate: 1,
      near: near,
      far: far,
      x: cam.target.x,
      y: cam.target.y,
      z: cam.target.z
    }
    this.to3Dtween = new TWEEN.Tween(c)
    this.to3Dtween.to({
      fov: 65,
      lat: toView ? 0 : 31,
      zoom: 960000,
      rate: 0,
      near: 500,
      far: 1000000,
      x: dx,
      y: dy,
      z: dz
    }, 1000)
    this.to3Dtween.onUpdate(() => {
      cam.fov = c.fov
      cam.lat = c.lat
      cam.camera.near = c.near
      cam.camera.far = c.far
      cam.zoom = c.zoom * Math.tan(THREE.MathUtils.degToRad(3 / 2)) / Math.tan(THREE.MathUtils.degToRad(c.fov / 2))
      if (toView) {
        cam.zoom = cam.zoom * c.rate + (1 - c.rate) * 1000
        cam.target.x = c.x
        cam.target.y = c.y
        cam.target.z = c.z
      }
      cam.camera.updateProjectionMatrix()
    })
    this.to3Dtween.easing(TWEEN.Easing.Quadratic.InOut)

    return new Promise((resolve, reject) => {
      this.to3Dtween.onComplete(() => {
        cam.orthCamera.zoom = 1
        cam.cameraType = true
        if (toView) {
          cam.cameraMode = true
          cam.cameraType = false
          cam.lon += 180
        }
        resolve()
      })
      this.to3Dtween.start()
    })
  }

  /**
   * 正交相机下降到全景视角
   * @param {function} callBack 动画结束后的回调函数
   * @param {number} tlon 回调函数参数
   * @param {number} tlat 回调函数参数
   */
  async orth2Pano (targetPos, tlon = 0, tlat = 0) {

  }

  /**
   * [tween] 透视相机切换至全景视角动画
   * @param {function} callBack tween动画执行完毕后的回调函数
   * @param {number} tlon 目标经度
   * @param {number} tlat 目标纬度
   */
  async normal2Pano (targetPos, tlon = 0, tlat = 0) {
    // tween动画
    const vc = {
      x: this.cameraInstance.camera.position.x,
      y: this.cameraInstance.camera.position.y,
      z: this.cameraInstance.camera.position.z,
      lat: this.cameraInstance.lat
    }
    this.g2vtween = new TWEEN.Tween(vc)
    this.g2vtween.to({
      x: targetPos.x,
      y: targetPos.y,
      z: targetPos.z,
      lat: 0
    }, 1200)
    this.g2vtween.onUpdate(() => {
      this.cameraInstance.camera.position.x = vc.x
      this.cameraInstance.camera.position.y = vc.y
      this.cameraInstance.camera.position.z = vc.z
      this.cameraInstance.lat = vc.lat
    })
    this.g2vtween.onComplete(() => {
      this.g2vtween = null
    })
    this.g2vtween.easing(TWEEN.Easing.Sinusoidal.InOut)
    return new Promise((resolve, reject) => {
      this.g2vtween.onComplete(() => {
        this.g2vtween = null
        resolve()
      })
      this.g2vtween.start()
    })
  }

  /**
   * [tween] 切换至透视相机动画
   */
  async pano2Normal () {
    const cam = this.cameraInstance

    cam.v2gsign = true
    cam.cameraMode = false // change to god
    cam.lon = cam.lon + 180
    cam.lat = Math.max(30, Math.min(80, -cam.lat))
    cam.phi = THREE.MathUtils.degToRad(90 - cam.lat)
    cam.theta = THREE.MathUtils.degToRad(cam.lon)
    const destination = new THREE.Vector3()
    destination.x = Math.sin(cam.phi) * Math.cos(cam.theta)
    destination.y = Math.cos(cam.phi)
    destination.z = Math.sin(cam.phi) * Math.sin(cam.theta)
    cam.zoom = 20000
    destination.multiplyScalar(cam.zoom)
    destination.add(cam.target)

    const v2g = {
      x: cam.camera.position.x,
      y: cam.camera.position.y,
      z: cam.camera.position.z
    }
    this.v2gtween = new TWEEN.Tween(v2g)
    this.v2gtween.to({
      x: destination.x,
      y: destination.y,
      z: destination.z
    }, 1200)
    this.v2gtween.onUpdate(() => {
      cam.camera.position.x = v2g.x
      cam.camera.position.y = v2g.y
      cam.camera.position.z = v2g.z
      cam.camera.lookAt(cam.target)
    })
    this.v2gtween.easing(TWEEN.Easing.Quadratic.InOut)
    this.v2gtween.start()
    return new Promise((resolve, reject) => {
      this.v2gtween.onComplete(() => {
        resolve()
      })
      this.v2gtween.start()
    })
  }

  /**
   * 全景到正交方法
   */
  async pano2Orth () {
    return this.normal2Orth()
  }

  /**
   * 前往上帝视角
   */
  async toGod () {
    if (this.viewMode === GodViewMode.Panel) {
      return this.pano2Orth()
    } else {
      return this.pano2Normal()
    }
  }

  /**
   * 前往全景视角
   */
  async toPano () {

  }

  /**
   * 淡入淡出从上帝 2D 到全景模式
   * @param {number} idx 点位idx
   * @param {number} tlon 目标经度
   * @param {number} tlat 目标纬度
   * @param {function} onInvisible 回调函数
   */
  async fade2dToPano (idx, tlon, tlat, onInvisible) {
    await this.toOpacity(0)

    // TODO：从2D到单场景点，cameraMode is false，正交相机，目标：cameraMode=true，透视相机
    this.singleView.enterSingleView()

    const cam = this.cameraInstance
    cam.changeMainCameraTo(cam.persCamera) // 切回了透视相机
    cam.camera.near = 500
    cam.camera.far = 100000
    cam.camera.fov = 65
    cam.camera.position.copy(config.SingleView.CameraPosition)
    cam.zoom = 1000
    cam.lon = tlon
    cam.lat = tlat
    cam.camera.updateProjectionMatrix()
    cam.cameraMode = true
    cam.viewUpdate()

    cam.orthCamera.zoom = 1

    onInvisible()
    await Utils.waitFor(config.GodMode.FadeRecoverDelay)

    await this.toOpacity(1)
  }

  /**
   * 淡入淡出从上帝 3D 到全景模式
   * @param {number} idx 点位idx
   * @param {number} tlon 目标经度
   * @param {number} tlat 目标纬度
   * @param {function} onInvisible 回调函数
   */
  async fade3dToPano (idx, tlon, tlat, onInvisible) {
    await this.toOpacity(0)

    // 从3D到单场景点，cameraMode is false,透视相机，目标：cameraMode = true，透视相机
    this.singleView.enterSingleView()

    const cam = this.cameraInstance
    cam.camera.fov = 65
    cam.camera.position.copy(config.SingleView.CameraPosition)
    cam.lon = tlon
    cam.lat = tlat
    cam.camera.updateProjectionMatrix()
    cam.cameraMode = true
    cam.viewUpdate()

    onInvisible()
    await Utils.waitFor(config.GodMode.FadeRecoverDelay)

    await this.toOpacity(1)
  }

  /**
   * 淡入淡出到上帝 2D 模式
   * @param {function} onFinish 完成后的回调函数
   */
  async fadeTo2D (onFinish) {
    await this.toOpacity(0)
    this.singleView.exitSingleView()

    const cam = this.cameraInstance
    // 切换相机
    cam.cameraType = false
    cam.cameraMode = false
    cam.lon += 180
    cam.lon = ((cam.lon % 360) + 360) % 360
    cam.lon = cam.lon <= 90 ? 0 : cam.lon >= 270 ? 360 : 180
    cam.lat = 89.99
    cam.target.set(0, 0, 0)
    cam.fov = 3
    cam.camera.near = ConfigConst.ToNormalNear / Math.tan(THREE.MathUtils.degToRad(3 / 2))
    cam.camera.far = ConfigConst.ToNormalFar / Math.tan(THREE.MathUtils.degToRad(3 / 2))
    cam.zoom = 39460 * Math.tan(THREE.MathUtils.degToRad(65 / 2)) / Math.tan(THREE.MathUtils.degToRad(3 / 2))
    cam.camera.updateProjectionMatrix()

    cam.changeMainCameraTo(cam.orthCamera) // 切到正交
    cam.camera.updateProjectionMatrix()
    cam.godUpdate()

    onFinish()
    await Utils.waitFor(config.GodMode.FadeRecoverDelay)
    await this.toOpacity(1)
  }

  /**
   * 淡入淡出到上帝 3D 模式
   * @param {function} onFinish 完成后的回调函数
   * @param {THREE.Vector3} targetPos 目标位置
   */
  async fadeTo3D (onFinish, targetPos) {
    await this.toOpacity(0)
    this.singleView.exitSingleView()

    const cam = this.cameraInstance

    cam.v2gsign = true
    cam.cameraMode = false // change to god
    cam.lon = 0
    cam.lat = Math.max(30, Math.min(80, -cam.lat))
    cam.zoom = 39460

    cam.phi = THREE.MathUtils.degToRad(90 - cam.lat)
    cam.theta = THREE.MathUtils.degToRad(cam.lon)
    const destination = new THREE.Vector3()
    destination.x = Math.sin(cam.phi) * Math.cos(cam.theta)
    destination.y = Math.cos(cam.phi)
    destination.z = Math.sin(cam.phi) * Math.sin(cam.theta)
    destination.multiplyScalar(cam.zoom)
    cam.target.copy(targetPos)
    destination.add(cam.target)

    cam.camera.position.copy(destination)
    cam.camera.lookAt(cam.target)

    onFinish()
    await Utils.waitFor(config.GodMode.FadeRecoverDelay)
    await this.toOpacity(1)
  }

  /**
   * canvas透明度变化动画
   * @param {number} opacity Canvas透明度
   */
  async toOpacity (opacity) {
    const a = {
      opacity: this.renderer.renderer.domElement.style.opacity
    }
    this.fade = new TWEEN.Tween(a)
    this.fade.to({
      opacity: opacity
    }, (config.GodMode.FadeAllTime - config.GodMode.FadeRecoverDelay) / 2)
    this.fade.onUpdate(() => {
      this.renderer.renderer.domElement.style.opacity = Math.max(0, a.opacity)
    })
    return new Promise((resolve, reject) => {
      this.fade.onComplete(() => {
        resolve()
      })
      this.fade.start()
    })
  }
}
